import { Card } from 'antd'
import styled from 'styled-components'

import sizes from 'src/styles/theme/sizes'
import colors from 'src/styles/theme/colors'

export const ProductStyled = styled.div`
  background-color: #f4f4fc;
  padding: 30px 20px;
  .breadcrumb {
    display: none;
  }
  .ant-breadcrumb li:last-child {
    color: #030852 !important;
  }
  @media screen and (min-width: ${sizes.sm}) {
    padding: 40px;
    .breadcrumb {
      display: unset;
      color: #030852 !important;
    }
  }
`

export const CardStyled = styled(Card)`
  margin-top: 20px;
  border-radius: 16px;
  color: #030852;
  background-color: transparent;
  .card-container {
    display: grid;
    grid-template-rows: auto 1fr;
    flex-wrap: wrap;
    gap: 40px;
    @media screen and (min-width: ${sizes.md}) {
      grid-template-columns: 4fr 6fr;
      grid-template-rows: unset;
    }
  }
  .img-container {
    min-width: 100px;
    max-height: 400px;
    img {
      width: 100%;
      max-height: 400px;
      object-fit: contain;
    }
  }
  .title {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: #030852;
  }
  .subtitle {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }
  .description-list {
    padding-left: 1rem;
    margin-bottom: 20px;
    color: #888aaf;
    li {
      list-style: disc;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
    }
  }
  .form-group {
    display: grid;
    width: 100%;
    gap: 0 20px;
    .ant-form-item-label {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
    }
    .ant-input-number {
      width: 100%;
    }
    @media screen and (min-width: ${sizes.sm}) {
      grid-template-columns: 3fr 1fr;
    }
  }
  .divider {
    width: 100%;
    height: 1px;
    background: ${colors.footerBackground};
    margin: 15px 0 40px 0;
  }
  .actions {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    @media screen and (min-width: ${sizes.sm}) {
      flex-wrap: nowrap;
    }
    & .ant-btn-primary:nth-child(1) {
      width: 100%;
    }
  }
`
